import type { ElementType } from 'react';

import {
  Atom,
  BankOfScotland,
  BankPlaceholder,
  Barclays,
  Halifax,
  Hsbc,
  Lloyds,
  Metro,
  Monzo,
  N26,
  Nationwide,
  Natwest,
  Rbs,
  Revolut,
  Santander,
  StandardCharteredBank,
  Starling,
  Tandem,
  Transferwise,
  Tsb,
  Virgin,
} from '../images/bank-logos';

import { findBank } from './utilities';

interface BankLogoFromSortcodeProps {
  sortCodePartial: string | null;
  bankPlaceholderIconAlt: string;
}

const ukBankComponents: Record<string, ElementType> = {
  Atom,
  BankOfScotland,
  Barclays,
  Halifax,
  Hsbc,
  Lloyds,
  Metro,
  Monzo,
  N26,
  Nationwide,
  Natwest,
  Rbs,
  Revolut,
  Santander,
  StandardCharteredBank,
  Starling,
  Tandem,
  Transferwise,
  Tsb,
  Virgin,
};

export const BankLogoFromSortcode = ({
  sortCodePartial,
  bankPlaceholderIconAlt,
}: BankLogoFromSortcodeProps) => {
  const bank = findBank(sortCodePartial);

  const BankComponent =
    !!bank && bank in ukBankComponents ? ukBankComponents[bank] : null;

  return BankComponent ? (
    <BankComponent />
  ) : (
    <BankPlaceholder alt={bankPlaceholderIconAlt} />
  );
};
